export default __webpack_public_path__ + "a247b439e9e645919733f77bc266f95f.png";